import React from "react";
import CmmsRecurringSchedules from "../features/cmmsRecurringSchedules";

export default function CmmsRecurringSchedulesPage() {
  return (
    <CmmsRecurringSchedules />
  );
}
